export default {"src":"/_next/static/media/login-background.4023982c.svg","height":484,"width":476,"blurWidth":0,"blurHeight":0};